/**
 * パスB: getUserMedia の映像を <video> としてキャンバスの背後に敷く(計画書§3)。
 */
export class CameraBackground {
  private video: HTMLVideoElement | null = null;
  private stream: MediaStream | null = null;

  /** ユーザージェスチャー後に呼ぶこと(権限プロンプトが出る) */
  async start(container: HTMLElement): Promise<void> {
    this.stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: 'environment',
        width: { ideal: 1920 },
        height: { ideal: 1080 },
      },
      audio: false,
    });
    const video = document.createElement('video');
    video.id = 'camera-background';
    video.playsInline = true; // iOSでフルスクリーン化させない
    video.muted = true;
    video.autoplay = true;
    video.srcObject = this.stream;
    container.prepend(video);
    await video.play();
    this.video = video;
  }

  stop(): void {
    this.stream?.getTracks().forEach((t) => t.stop());
    this.stream = null;
    this.video?.remove();
    this.video = null;
  }

  get active(): boolean {
    return this.video !== null;
  }
}
